import React, { Component } from "react";

import img1 from './images/codeexampler404-error.jpg'

export default class Nodatafound extends Component {

  render() {
    return (
      <div >
       
<a href="/" alt="CodeExampler Learn Free Coding Website 404 Page">
  <img
          src={img1}
              width="100%"
              alt="codeExampler Website 404 Page"
            /></a>
<br/>
  </div>
    
     
    
    );
  }
}